import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=41b56204&scoped=true&"
import script from "./joinList.vue?vue&type=script&lang=js&"
export * from "./joinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b56204",
  null
  
)

export default component.exports